export default "__VITE_ASSET__BwnCGksV__"